import { render, staticRenderFns } from "./nutritionalAnalysis.vue?vue&type=template&id=5c1b5aa5&scoped=true"
import script from "./nutritionalAnalysis.vue?vue&type=script&lang=js"
export * from "./nutritionalAnalysis.vue?vue&type=script&lang=js"
import style0 from "./nutritionalAnalysis.vue?vue&type=style&index=0&id=5c1b5aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b5aa5",
  null
  
)

export default component.exports